<template lang="html">
  <server-form
    v-slot="slotProps"
    :form-action="formAction"
    :form="form">

    <my360Textarea
      :form="form"
      :validation-name="__('Question')"
      :generic-error-msg="__('question_missed')"
      :autofocus="true"
      name="content"
      prop="content"
      type="textarea"
      min="0"
      max="100"
      required/>

  </server-form>
</template>
<script>
import formAction from '../mixins/formAction'

export default {
  name: 'GiveOngoingFeedback',

  mixins: [formAction],

  data () {
    return {
      form: {}
    }
  }
}
</script>
